import React from "react";
import ModalInfoCard from "../../../../../../components/Cards/ModalInfoCard";
import SectionDivider from "../../../../../Dividers/SectionDivider";
import InfoRow from "../../../../../Rows/InfoRow";

interface Props {
  origin: string;
  destination: string;
}

const TransferBranchesSection: React.FC<Props> = ({ origin, destination }) => {
  return (
    <>
      {/* ✅ Título + divisor */}
      <SectionDivider title="Sucursales" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {/* ✅ Origen */}
        <ModalInfoCard title="Origen">
          <InfoRow label="Sucursal" value={origin} />
        </ModalInfoCard>

        {/* ✅ Destino */}
        <ModalInfoCard title="Destino">
          <InfoRow label="Sucursal" value={destination} />
        </ModalInfoCard>
      </div>
    </>
  );
};

export default TransferBranchesSection;
